import { DashboardTile, SensorData } from 'commons/src/models/commonTypeScript';
import { emptyAction } from '../actions';
import { PublicDashboardActions, PublicDashboardActionType } from '../actions/publicDashboardActions';
import { PublicDashboardProps } from '../models/commons';

export type PublicDashboardStore = {
    tiles: DashboardTile[];
    sensorData: SensorData;
    aggregateType: string;
    minValues: { [tileId: string]: { [interval: string]: number } };
    averageValues: { [tileId: string]: { [interval: string]: number } };
    dashboardProps?: PublicDashboardProps;
};

const initialState: PublicDashboardStore = {
    tiles: [],
    sensorData: {},
    minValues: {},
    averageValues: {},
    dashboardProps: undefined,
    aggregateType: 'main',
};

export default (state = initialState, action: PublicDashboardActions = emptyAction): PublicDashboardStore => {
    switch (action.type) {
        case PublicDashboardActionType.FetchPublicDashboardSuccess:
            return {
                ...state,
                dashboardProps: action.payload.info,
            };
        case PublicDashboardActionType.FetchPublicDashboardTilesSuccess:
            return {
                ...state,
                tiles: action.payload.tiles,
                sensorData: action.payload.sensorData,
                minValues: action.payload.minValues,
                averageValues: action.payload.averageValues,
            };
        default:
            return state;
    }
};
